/* Promo popup replacement: original artwork, geometry, links and targeting. */
(() => {
  'use strict';
  const configNode = document.getElementById('pbcm-popup-config');
  if (!configNode || document.getElementById('pbcm-container')) return;
  const campaigns = JSON.parse(configNode.textContent);
  const url = window.location.href.toLowerCase();
  const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  function matches(rule) {
    const [op, ...args] = rule;
    if (op === 'and') return args.every(matches);
    if (op === 'or') return args.some(matches);
    if (op !== 'current_url') return false;
    const found = args[1].split('\n').filter(Boolean).some(s => url.includes(s.toLowerCase()));
    return args[0] === 'contains' ? found : args[0] === 'does_not_contain' ? !found : false;
  }
  function suppressed(c) {
    if (!c.repeat) return false;
    const cookie = document.cookie.split('; ').find(s => s.startsWith(`pbcm_suppress_${c.displayId}=`));
    return !!cookie && (c.repeat === -1 || Date.now()/1000 - Number(cookie.split('=')[1]) < c.repeat);
  }
  function remember(c) {
    if (!c.repeat) return;
    document.cookie = `pbcm_suppress_${c.displayId}=${Math.round(Date.now()/1000)}; Max-Age=${c.repeat === -1 ? 315360000 : c.repeat}; Path=/; SameSite=Lax; Secure`;
  }
  const root = document.createElement('div');
  root.id = 'pbcm-container';
  const inner = document.createElement('div');
  inner.id = 'pbcm-inner-container';
  root.append(inner); document.body.append(root);
  let opened = null, previousFocus = null;
  const entries = new Map();
  function close() {
    if (!opened) return;
    opened.popup.classList.remove('pbcm-open');
    opened.popup.hidden = true;
    if (opened.tab) opened.tab.setAttribute('aria-expanded', 'false');
    opened = null;
    if (previousFocus?.isConnected) previousFocus.focus({preventScroll: true});
  }
  function scale(entry) {
    const wrap = entry.popup.querySelector('.pbcm-popup-content-wrap');
    const content = entry.popup.querySelector('.pbcm-popup-inner-content-wrap');
    const factor = Math.min(wrap.clientWidth / content.offsetWidth, 1);
    content.style.transform = factor === 1 ? 'none' : `scale(${factor})`;
    content.style.transformOrigin = 'top left';
    const dismiss = entry.popup.querySelector('.pbcm-dismiss-content');
    dismiss.style.transform = `scale(${1/factor})`;
    dismiss.style.transformOrigin = 'top right';
  }
  function open(entry) {
    if (opened === entry) return;
    close(); previousFocus = document.activeElement; opened = entry;
    entry.popup.hidden = false; entry.popup.classList.add('pbcm-open');
    if (entry.tab) entry.tab.setAttribute('aria-expanded','true');
    remember(entry.c); scale(entry);
    const dialog = entry.popup.querySelector('[role="dialog"]');
    dialog.tabIndex = -1; dialog.style.outline = 'none'; dialog.focus({preventScroll:true});
  }
  function makeTab(entry) {
    const t = mobile ? entry.c.mobileTab : entry.c.tab;
    if (t.style === 'none') return;
    const container = document.createElement('div');
    container.className = `pbcm-tab-container pbcm-${t.position} pbcm-top pbcm-left pbcm-${t.style}`;
    container.setAttribute('role','complementary');
    container.setAttribute('aria-label','Marketing and promotions tab '+t.position);
    const button = document.createElement('div');
    button.className = `pbcm-tab pbcm-top pbcm-left pbcm-${t.style}`;
    button.setAttribute('role','button');button.tabIndex=0;
    button.setAttribute('aria-haspopup','dialog');button.setAttribute('aria-expanded','false');
    button.style.backgroundColor=t.bg_color;button.style.color=t.text_color;
    const caret=document.createElement('div');caret.className='pbcm-caret pbcm-caret-down';caret.style.color=t.text_color;
    const text=document.createElement('div');text.className='pbcm-tab-text';text.textContent=t.text;
    text.style.color=t.text_color;text.style.fontFamily=t.font+', Helvetica, Arial, Sans Serif';
    button.append(caret,text);container.append(button);inner.append(container);entry.tab=button;
    const toggle=()=>opened===entry?close():open(entry);
    button.addEventListener('click',toggle);
    button.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();toggle();}});
  }
  const forced = new URLSearchParams(location.search).get('pbcm_popup');
  campaigns.forEach(c => {
    const eligible = matches(c.conditions);
    if (!eligible && forced !== String(c.id)) return;
    const template=document.getElementById(`pbcm-campaign-${c.id}`);
    const clone=template.content.cloneNode(true);
    const popup=clone.querySelector('.pbcm-popup-container');
    popup.hidden=true;
    const dismiss=popup.querySelector('.pbcm-dismiss-content');
    dismiss.tabIndex=0;dismiss.classList.toggle('mobile',mobile);
    popup.querySelectorAll('[tabindex="1"]').forEach(e=>e.tabIndex=0);
    const entry={c,popup,tab:null};entries.set(c.id,entry);inner.append(popup);
    dismiss.addEventListener('click',close);
    dismiss.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();close();}});
    popup.addEventListener('click',e=>{if(!e.target.closest('.pbcm-popup-inner-content-wrap'))close();});
    popup.querySelectorAll('button[data-link]').forEach(b=>b.addEventListener('click',()=>{location.href=b.dataset.link;}));
    if(eligible)makeTab(entry);
    if(forced === String(c.id))open(entry);
    else if(eligible && !forced && c.delay>=0 && !suppressed(c))setTimeout(()=>{if(!opened && !suppressed(c))open(entry);},c.delay);
  });
  document.addEventListener('keydown',e=>{
    if(!opened)return;
    if(e.key==='Escape'){e.preventDefault();close();return;}
    if(e.key!=='Tab')return;
    const items=[...opened.popup.querySelectorAll('button,a[href],[tabindex="0"]')].filter(el=>el.getClientRects().length);
    if(!items.length)return;
    const first=items[0],last=items[items.length-1];
    if(e.shiftKey&&(document.activeElement===first||document.activeElement===opened.popup.querySelector('[role="dialog"]'))){e.preventDefault();last.focus();}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
  });
  window.addEventListener('resize',()=>{if(opened)scale(opened);});
  // Manual triggers for campaigns whose automatic display is disabled.
  document.addEventListener('click',e=>{
    const link=e.target.closest('a[href]');if(!link)return;
    const match=link.getAttribute('href').match(/^#(?:pbcm|privy)-(?:campaign-)?(\d+)$/);
    if(match&&entries.has(Number(match[1]))){e.preventDefault();open(entries.get(Number(match[1])));}
  });
})();
